/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { Search as Search$1 } from '@manulife/mux-cds-icons';
import PropTypes from 'prop-types';
import i18n from '../../../lang/i18n/index.js';
import { safeRest, noop } from '../../../utils/functions.js';
import HeaderButton from './HeaderButton.js';
import { jsx } from 'react/jsx-runtime';
import useLang from '../../../hooks/useLang.js';

var _excluded = ["id", "label", "icon", "onClick"];
var Search = function Search(_ref) {
  var id = _ref.id,
    label = _ref.label,
    icon = _ref.icon,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === undefined ? noop : _ref$onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var lang = useLang();
  var safeProps = safeRest(rest);
  return /*#__PURE__*/jsx(HeaderButton, _objectSpread({
    id: id,
    label: label || i18n[lang].utilityHeader.searchLabel,
    icon: icon || /*#__PURE__*/jsx(Search$1, {
      "aria-hidden": true,
      title: "search-icon"
    }),
    onClick: onClick
  }, safeProps), "search");
};
process.env.NODE_ENV !== "production" ? Search.propTypes = {
  /** id for the DOM element */
  id: PropTypes.string,
  /** label displayed on Search button */
  label: PropTypes.node,
  /** icon for Search button */
  icon: PropTypes.node,
  /** onClick handler for Search button */
  onClick: PropTypes.func
} : undefined;
process.env.NODE_ENV !== "production" ? Search.displayName = 'Search' : undefined;

export { Search as default };
